var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEarthHeart40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9932 34.4894C25.2737 34.4894 31.9864 27.7767 31.9864 19.4961C31.9864 11.2156 25.2737 4.50293 16.9932 4.50293C8.71269 4.50293 2 11.2156 2 19.4961C2 27.7767 8.71269 34.4894 16.9932 34.4894Z",
    fill: "#D9D9D9",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2384_9510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 32,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9932 34.4894C25.2737 34.4894 31.9864 27.7767 31.9864 19.4961C31.9864 11.2156 25.2737 4.50293 16.9932 4.50293C8.71269 4.50293 2 11.2156 2 19.4961C2 27.7767 8.71269 34.4894 16.9932 34.4894Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.946688
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2384_9510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9932 34.4894C25.2737 34.4894 31.9864 27.7767 31.9864 19.4961C31.9864 11.2156 25.2737 4.50293 16.9932 4.50293C8.71269 4.50293 2 11.2156 2 19.4961C2 27.7767 8.71269 34.4894 16.9932 34.4894Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2397 3.73438C20.2397 3.73438 17.1197 5.52676 17.0648 8.24473C17.0099 10.9627 20.5637 9.50214 20.5637 11.4648C20.5637 13.4275 18.247 13.7897 16.1625 11.7945C14.078 9.7993 11.7685 9.57388 9.69816 11.3574C7.62782 13.141 7.2877 17.8334 10.8535 18.5598C14.4194 19.2863 14.9393 19.5693 14.9393 23.1789C14.9393 26.7885 15.4088 27.5697 18.2041 27.5697C20.9994 27.5697 19.5051 24.6502 20.5637 22.7591C21.6223 20.8679 23.4519 19.8809 23.4519 18.3434C23.4519 16.8059 19.9008 17.0717 20.5637 14.9253C21.2267 12.7791 24.3726 13.9425 25.8978 13.0459C27.4231 12.1493 28.4663 8.62564 28.0499 8.24473C27.8577 8.06894 27.1701 7.07286 25.061 5.78644C24.3016 5.3233 23.7181 4.72957 22.7935 4.43384C21.7302 4.00549 20.2397 3.73438 20.2397 3.73438Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1873 37.7879L23.6532 30.9114C22.2378 29.4219 22.1238 27.1215 23.385 25.4993C24.8007 23.6783 27.4287 23.359 29.2393 24.7881L30.1873 25.5362L31.576 24.562C33.4355 23.2574 36.0016 23.7168 37.293 25.5855C38.3943 27.1791 38.2274 29.3267 36.893 30.731L30.1873 37.7879Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEarthHeart40);
export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart40.9dfdaca16300b0a640f5fe685124532c.svg";
export { ForwardRef as ReactComponent };